import React from 'react';
import { Edit3, X } from 'lucide-react';
import { SmallText } from '../../../components/brand/BrandTypography';
import { IconButton, PrimaryButton, TertiaryButton } from '../../../components/brand/BrandButton';

const PatternsTab = ({ cyclePatterns, editingPattern, setEditingPattern, onSave }) => {
    return (
        <div className="space-y-4">
            <div className="mb-4 p-4 bg-[#7D8E95]/20 rounded-xl border border-[#1D6B6B]/20">
                <SmallText className="text-[#1D6B6B]">
                    <strong>Relationship Cycle Patterns</strong> - Click on any pattern to edit it. Common negative patterns couples fall into.
                </SmallText>
            </div>
            <div className="grid grid-cols-1 gap-4">
                {cyclePatterns.map(pattern => (
                    <div 
                        key={pattern.pattern_id} 
                        className="bg-white rounded-xl border border-[#FFBB98] p-5 cursor-pointer hover:border-[#1D6B6B]/50 transition-colors"
                        onClick={() => setEditingPattern({...pattern})}
                    >
                        <div className="flex items-start justify-between mb-2">
                            <h4 className="font-medium text-[#1D6B6B] text-lg">{pattern.name}</h4>
                            <Edit3 className="w-4 h-4 text-[#7D8E95]" />
                        </div>
                        <p className="text-sm text-[#7D8E95] mb-4">{pattern.description}</p>
                        <div className="space-y-2 mb-4">
                            {pattern.details?.map((detail, i) => (
                                <p key={i} className="text-sm text-[#1D6B6B] flex items-start gap-2">
                                    <span className="text-[#1D6B6B]">•</span>
                                    {detail}
                                </p>
                            ))}
                        </div>
                        <div className="pt-3 border-t border-[#FFBB98]">
                            <span className="text-xs text-[#7D8E95] font-medium">Soft Insight:</span>
                            <p className="text-sm text-[#7D8E95] mt-1 italic">{pattern.soft_insight}</p>
                        </div>
                    </div>
                ))}
            </div>
            
            {editingPattern && (
                <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
                    <div className="bg-white rounded-2xl max-w-lg w-full max-h-[90vh] overflow-y-auto p-6">
                        <div className="flex items-center justify-between mb-4">
                            <h3 className="text-lg font-medium">Edit Cycle Pattern</h3>
                            <IconButton onClick={() => setEditingPattern(null)}>
                                <X className="w-5 h-5" />
                            </IconButton>
                        </div>
                        <div className="space-y-4">
                            <div>
                                <label className="text-sm text-[#7D8E95] mb-1 block">Name</label>
                                <input 
                                    value={editingPattern.name} 
                                    onChange={(e) => setEditingPattern({...editingPattern, name: e.target.value})}
                                    className="w-full p-3 border border-[#FFBB98] rounded-xl"
                                />
                            </div>
                            <div>
                                <label className="text-sm text-[#7D8E95] mb-1 block">Description</label>
                                <textarea 
                                    value={editingPattern.description} 
                                    onChange={(e) => setEditingPattern({...editingPattern, description: e.target.value})}
                                    className="w-full p-3 border border-[#FFBB98] rounded-xl"
                                    rows={3}
                                />
                            </div>
                            <div>
                                <label className="text-sm text-[#7D8E95] mb-1 block">Details (one per line)</label>
                                <textarea 
                                    value={editingPattern.details?.join('\n') || ''} 
                                    onChange={(e) => setEditingPattern({...editingPattern, details: e.target.value.split('\n').filter(d => d.trim())})}
                                    className="w-full p-3 border border-[#FFBB98] rounded-xl"
                                    rows={4}
                                />
                            </div>
                            <div>
                                <label className="text-sm text-[#7D8E95] mb-1 block">Soft Insight</label>
                                <textarea 
                                    value={editingPattern.soft_insight} 
                                    onChange={(e) => setEditingPattern({...editingPattern, soft_insight: e.target.value})}
                                    className="w-full p-3 border border-[#FFBB98] rounded-xl"
                                    rows={2}
                                />
                            </div>
                        </div>
                        <div className="flex gap-3 mt-6">
                            <TertiaryButton onClick={() => setEditingPattern(null)} className="flex-1">Cancel</TertiaryButton>
                            <PrimaryButton onClick={() => onSave(editingPattern)} className="flex-1">Save</PrimaryButton>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default PatternsTab;
